import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-complain-list-expand",
  templateUrl: "./complain-list-expand.component.html",
  styleUrls: ["./complain-list-expand.component.scss"],
})
export class ComplainListExpandComponent implements OnInit {
  // _rowData: any;

  // @Output() dataUpdated = new EventEmitter<any>();

  // @Input()
  // set rowData(value) {
  //   this._rowData = value;
  //   if(!_.isUndefined(this._rowData)){

  //   }
  // }
  // get rowData() {
  //   return this._rowData;
  // }

  // statusOptions: Array<any>;
  // newStatus: any;
  // newComment: string;
  // userInfo: any;
  // isActionAllowed: boolean = false;
  // constructor(private service: ComplaintService, private ss: SessionService) {
  //   this.statusOptions = [
  //     { name: "UNSOLVED", value: "UNSOLVED" },
  //     { name: "SOLVED", value: "SOLVED" },
  //     { name: "INPROGRESS", value: "INPROGRESS" },
  //     { name: "HOLD", value: "HOLD" }
  //   ];
  // }

  // updateStatus() {
  //   this._rowData.status = this.newStatus.value;
  //   if (this._rowData.status === "SOLVED") {
  //     this._rowData.resolvedBy = this.userInfo.id;
  //   }
  //   this.service.updateComplainStatus(this._rowData).subscribe(resp => {
  //     this.dataUpdated.emit(this._rowData);
  //     window.location.reload(true);
  //   });
  // }

  // addComment() {
  //   let d = {
  //     text: this.newComment,
  //     entityType: "COMPLAIN",
  //     complains: this._rowData.id
  //   };
  //   this.service.addComment(d).subscribe(resp => {
  //     this._rowData.comments.push(resp);
  //     //this.dataUpdated.emit(this._rowData);
  //     this.newComment = "";
  //   });
  // }

  ngOnInit() {
    // this.statusOptions =  this.statusOptions.filter(
    //   function(e) {
    //     return this._rowData.status !== e.value;
    //   },
    //   this
    // );
    // this.userInfo = this.ss.getUserInfo();
    // if (
    //   this.userInfo.role === "KARYA_KARTA" &&
    //   this._rowData.status !== "SOLVED"
    // ) {
    //   this.isActionAllowed = true;
    // }
  }
}
